<template>
    <div class="wrap-sc2-st3_10 global-offset">
        <div class="top-panel">
            <div class="search">
                <div class="arrow"></div>
                <div class="info">
                    <p>Search</p>

                    <div class="breadcrumbs-sc">
                        <span>Home</span> <i class="glyphicon glyphicon-menu-right"></i> Search
                    </div>
                </div>
            </div>

            <div class="actions-block">
                <div class="item">
                    <img class="icon" src="//img.netwrix.com/elements/onlineDemo/ui_icons/who_ico.svg" alt="who">
                    <div class="text">Who</div>
                </div>
                <div class="item">
                    <img class="icon" src="//img.netwrix.com/elements/onlineDemo/ui_icons/action_ico.svg" alt="Action">
                    <div class="text">Action</div>
                </div>
                <div class="item">
                    <img class="icon" src="//img.netwrix.com/elements/onlineDemo/ui_icons/what_ico.svg" alt="What">
                    <div class="text">What</div>
                </div>
                <div class="item">
                    <img class="icon" src="//img.netwrix.com/elements/onlineDemo/ui_icons/when_ico.svg" alt="When">
                    <div class="text">When</div>
                </div>
                <div class="item">
                    <img class="icon" src="//img.netwrix.com/elements/onlineDemo/ui_icons/where_ico.svg" alt="Where">
                    <div class="text">Where</div>
                </div>
            </div>

            <div class="tools">
                Tools
            </div>
        </div>

        <div class="search-block">
            <div class="search-input-fake">
                <div class="wrapper">
                    <div class="filter who">
                        <div class="key-block">Who</div>
                        <div class="value-block">"Enterprise\T.Simpson"</div>
                    </div>
                </div>
            </div>

            <div class="buttons">
                <div class="button new-window">Open in new window</div>
                <div class="search-button-wrapper">
                    <div class="btn button search">Search
                    </div>
                </div>
                <div class="button advanced">Advanced mode
                </div>
            </div>
        </div>

        <div class="table-block">
            <div class="table">
                <div class="row head">
                    <div class="who">Who</div>
                    <div class="type">Object type</div>
                    <div class="action">Action</div>
                    <div class="what">What</div>
                    <div class="where">Where</div>
                    <div class="when">When</div>
                </div>

                <div class="table-data">
                    <Loader v-show="loader"></Loader>

                    <div v-for="(item, index) in tableData" class="row" :key="index">
                        <div class="head-block">
                            <div class="who">
                                <p>{{item['Who']}}</p>
                                <p class="details">{{item['Details']}}</p>
                            </div>
                            <div class="type">{{item['Object type']}}</div>
                            <div class="action">
                                <span :style="{'background-color': getActionColor(item['Action'])}"></span>
                                {{item['Action']}}
                            </div>
                            <div class="what" v-html="item['What']"></div>
                            <div class="where">{{item['Where']}}</div>
                            <div class="when" v-html="item['When']"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="details">
                <div class="head">
                    Details
                </div>
                <div class="controls">
                    Full Screen
                </div>
                <div class="details-table">
                    <div class="title">
                        Activity record details
                    </div>
                    <div>
                        <div class="col-left">Data source:</div>
                        <div class="col-right">Logon Activity</div>
                    </div>
                    <div>
                        <div class="col-left">Monitoring plan:</div>
                        <div class="col-right">AD Monitoring</div>
                    </div>
                    <div>
                        <div class="col-left">Item:</div>
                        <div class="col-right">enterprise.com (Domain)</div>
                    </div>
                    <div>
                        <div class="col-left">Workstation:</div>
                        <div class="col-right">legacy.enterprise.co.uk</div>
                    </div>
                </div>

                <div class="details-table">
                    <div class="title">
                        User account details
                    </div>
                    <div>
                        <div class="col-left">Account:</div>
                        <div class="col-right">ENTERPRISE\T.Simpson</div>
                    </div>
                    <div>
                        <div class="col-left">Full name:</div>
                        <div class="col-right">Tom Simpson</div>
                    </div>
                    <div>
                        <div class="col-left">Display name:</div>
                        <div class="col-right">Tom Simpson</div>
                    </div>
                    <div>
                        <div class="col-left">ADStatus:</div>
                        <div class="col-right">Enabled</div>
                    </div>
                    <div>
                        <div class="col-left">Department:</div>
                        <div class="col-right">IT</div>
                    </div>
                    <div>
                        <div class="col-left">Last logon:</div>
                        <div class="col-right">T.Simpson@enterprise.com</div>
                    </div>
                    <div>
                        <div class="col-left">Member of:</div>
                        <div class="col-right"><span>7 groups</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="line"></div>
    </div>
</template>

<script>
  import {mapState} from 'vuex';
  import Loader from '@/components/utils/Loader';
  import spacers from '@/mixins/spacers';

  export default {
    name: 'search-screen-sc2-st3_10',
    mixins: [spacers],
    components: {
      Loader,
    },
    data() {
      return {
        currentLeftSpacer: '',
        currentRightSpacer: '',
        loader: true,
        tableData: [],
      };
    },
    computed: {
      ...mapState('guide', ['currentStep', 'getActionColor']),
    },
    mounted() {
      setTimeout(() => {
        this.loader = false;
        this.tableData = [
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "USB Hub",
            "Action": "Added",
            "What": "\\System Information\\Components\\USB Hub\\VID_1...",
            "Where": "WTK37",
            "When": "10/29/2018<br>8:12:13 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "http://sp.enterprise.com/RnD/<br>datexp.exe",
            "Where": "http://sp.enterprise.com/RnD:4775",
            "When": "10/29/2018<br>12:16:20 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "http://sp.enterprise.com/Partnerships/datexp.exe",
            "Where": "http://sp.enterprise.com/Partnerships:4775",
            "When": "10/29/2018<br>12:16:20 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "http://sp.enterprise.com/HR/<br>datexp.exe",
            "Where": "http://sp.enterprise.com/HR:4775",
            "When": "10/28/2018<br>12:16:19 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "http://sp.enterprise.com/Marketing/<br>datexp.exe",
            "Where": "http://sp.enterprise.com/Marketing:4775",
            "When": "10/28/2018<br>12:16:18 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "http://sp.enterprise.com/Customer<br> Research/datexp.exe",
            "Where": "http://sp.enterprise.com/Customer Research:4775",
            "When": "10/28/2018<br>12:16:17 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "http://sp.enterprise.com/Corp/<br>datexp.exe",
            "Where": "http://sp.enterprise.com/Corp:4775",
            "When": "10/28/2018<br>12:16:15 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\IT\\datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:12 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\Finance\\datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:12 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\Main Office Backup\\<br>datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:12 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\LA Office Backup\\<br>datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:12 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\Sales\\Reports\\2018\\<br>datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:12 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\RnD\\datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:11 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\Product Management\\<br>datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:11 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\Strategic Alliances\\<br>datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:11 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Added",
            "What": "\\\\pdc\\shared\\Engineering\\datexp.exe",
            "Where": "pdc",
            "When": "10/28/2018<br>12:08:11 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Main Office Backup\\<br>Corp\\T.Simpson",
            "Where": "pdc",
            "When": "10/28/2018<br>12:02:56 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Main Office Backup\\<br>Finance\\T.Simpson",
            "Where": "pdc",
            "When": "10/28/2018<br>12:02:56 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Main Office Backup\\<br>T.Simpson",
            "Where": "pdc",
            "When": "10/28/2018<br>12:02:56 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Bonus_2013.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:01:45 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Bonus_2014.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Bonus_2015.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Bonus_2016.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Bonus_2017.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Bonus_2018.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Payroll_2014.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Payroll_2015.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Payroll_2016.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Payroll_2017.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "File",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Finance\\Employees\\<br>T.Simpson\\T.Simpson_Payroll_2018.xlsx",
            "Where": "pdc",
            "When": "10/28/2018<br>12:00:34 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Employee Data\\<br>T.Simpson",
            "Where": "pdc",
            "When": "10/28/2018<br>11:58:59 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Photos\\T.Simpson",
            "Where": "pdc",
            "When": "10/28/2018<br>11:58:38 AM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Removed",
            "What": "\\\\pdc\\shared\\Corp\\T.Simpson",
            "Where": "pdc",
            "When": "10/28/2018<br>11:57:56 PM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Read (Failed Attempt)",
            "What": "\\\\pdc\\shared\\Accounting",
            "Where": "pdc",
            "When": "10/28/2018<br>11:57:56 PM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Read (Failed Attempt)",
            "What": "\\\\pdc\\shared\\Accounting",
            "Where": "pdc",
            "When": "10/28/2018<br>11:56:32 PM",
          },
          {
            "Who": "ENTERPRISE\\T.Simpson",
            "Object type": "Folder",
            "Action": "Read (Failed Attempt)",
            "What": "\\\\pdc\\shared\\ Business Improvements",
            "Where": "pdc",
            "When": "10/28/2018<br>11:54:40 PM",
          },
        ];
      }, 1000);
    }
  }
</script>

<style lang="less" scoped>
    .wrap-sc2-st3_10 {
        width: 1414px;
        position: relative;
    }

    .top-panel {
        margin-bottom: 32px;
        text-align: center;

        .search {
            width: 150px;
            position: absolute;
            left: 0;
            text-align: left;

            .arrow,
            .info {
                display: inline-block;
                vertical-align: top;
            }

            .arrow {
                width: 26px;
                height: 26px;
                background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_back_ico.svg) 0 8px no-repeat;
                margin-right: 12px;
            }

            .info {
                p {
                    font-size: 22px;
                    margin-bottom: 0;
                    color: #202020;
                }

                .breadcrumbs-sc {
                    color: #58595b;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 26px;

                    .glyphicon {
                        font-size: 12px;
                    }

                    span {
                        color: #0d71b9;
                    }
                }
            }
        }

        .actions-block {
            font-size: 0;
            padding-top: 10px;

            .item {
                display: inline-block;
                vertical-align: middle;
                text-align: center;
                margin: 0 36px;

                white-space: nowrap;

                .icon,
                .text {
                    display: inline-block;
                    vertical-align: middle;
                }

                .icon {
                    height: 20px;
                    margin-right: 9px;
                }

                .text {
                    font-size: 16px;
                }
            }
        }

        .tools {
            background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/tools_ico.svg) 0 50% no-repeat;
            background-size: 25px 100%;
            padding-left: 32px;

            position: absolute;
            right: 10px;
            top: 20px;

            &.active {
                cursor: pointer;
            }
        }
    }

    .search-block {
        margin-bottom: 18px;

        .search-input-fake {
            padding: 3px;
            border: 1px solid #ccc;

            .filter {
                @borderColor: #33669a;
                font-size: 0;

                .key-block,
                .value-block {
                    display: inline-block;
                    font-size: 13px;
                }

                .key-block {
                    padding: 2px 18px 2px 30px;
                    background-color: #cfeffe;

                    border: 1px solid @borderColor;
                }

                .value-block {
                    padding: 2px 10px;

                    border-top: 1px solid @borderColor;
                    border-right: 1px solid @borderColor;
                    border-bottom: 1px solid @borderColor;
                }

                &.data-source {
                    .key-block {
                        background: #cfeffe url(//img.netwrix.com/elements/onlineDemo/ui_icons/radiobutton_off_ico.v001.svg) 5px 3px no-repeat;
                        background-size: 14px;
                    }
                }

                &.who {
                    .key-block {
                        background: #cfeffe url(//img.netwrix.com/elements/onlineDemo/ui_icons/who_little_ico.v001.svg) 5px 3px no-repeat;
                        background-size: 14px;
                    }
                }
            }

            .search-field {
                padding-left: 4px;
            }

            .wrapper {
                display: inline-block;
                padding-right: 4px;

                &.bordered {
                    outline: 2px solid #da262e;
                    outline-offset: 2px;
                }

                & > div {
                    display: inline-block;
                    vertical-align: middle;
                }
            }
        }

        input {
            width: 100%;
            padding: 5px;

            &:disabled {
                background: #fff;
                border: 1px solid #ccc;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;
                color: #555;
            }
        }

        .search-button-wrapper {
            padding: 2px;
            outline: 2px solid transparent;
            transition: outline-color 200ms linear;

        }

        .buttons {
            text-align: center;
            margin-top: 16px;

            .search-button-wrapper {
                display: inline-block;
                margin: 0 45px;
            }

            .button {
                display: inline-block;
                font-size: 14px;

                &.new-window {
                    color: #0d71b9;

                    background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/open_in_new_window_ico.svg) 7px -2px no-repeat;
                    padding-left: 34px;
                    background-size: 22px 100%;
                }

                &.search {
                    border-radius: 0;
                    background-color: #1472bb;
                    padding: 5px 49px;

                    color: #ffffff;
                    text-transform: uppercase;
                }

                &.advanced {
                    background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/advanced_mode_ico.svg) 7px -2px no-repeat;
                    padding-left: 36px;
                    background-size: 22px 100%;

                    color: #0d71b9;

                    &.active {
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .table-block {
        p {
            margin-bottom: 0;
        }

        .table-data {
            position: relative;
            min-height: 320px;

            &.first-data {
                min-height: 1334px;
            }

            .row {
                height: 53px;
            }
        }

        .table {
            font-size: 12px;
            color: #202020;
            width: 1045px;
            display: inline-block;

            .row {
                margin: 0;
                padding: 9px 0;
                border-bottom: 1px solid #e2f2ff;
                cursor: pointer;

                &.bordered {
                    outline: 2px solid #da262e;
                }

                &:hover {
                    background-color: #dff3fe;
                }

                &.head {
                    padding: 0;
                    border-bottom: none;

                    &:hover {
                        background: none;
                    }

                    div {
                        font-weight: 600;
                        background-color: #d7effe;
                        padding: 3px 18px;
                        margin-left: 2px;
                    }

                    .who {
                        padding-left: 24px;
                        background: #d7effe;
                    }
                }

                &.expanded {
                    padding: 0;
                    outline: 2px solid #6ca8d4;

                    &.bordered {
                        outline: 2px solid #da262e;
                    }

                    &:hover {
                        background: none;
                    }

                    .head-block {
                        background-color: #b6e0fe;
                        width: 100%;
                        padding: 8px 0;

                        & > div {
                            display: inline-block;
                            vertical-align: top;
                        }
                    }

                    .expand {
                        padding: 12px 21px;

                        .buttons {
                            position: relative;
                        }

                        .btn {
                            display: inline-block;
                            border-radius: 0;
                            padding: 3px 48px 3px 24px;

                            &.exclude {
                                margin-right: 20px;
                                color: #ffffff;
                                background: #1472bb url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_right_white_ico.svg) no-repeat 97% 3px;
                                background-size: 20px 80%;

                            }

                            &.include {
                                color: #0d71b9;
                                border: 1px solid #0d71b9;

                                background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_right_blue_ico.svg) 92% 3px no-repeat;
                                background-size: 20px 80%;
                            }

                            &.bordered {
                                outline: 2px solid #da262e;
                                outline-offset: 2px;
                            }
                        }

                        .additional {
                            margin-top: 10px;
                            margin-bottom: 9px;

                            .item {
                                text-align: left;
                                margin-bottom: 2px;

                                .v-label,
                                .value {
                                    display: inline-block;
                                    vertical-align: top;
                                }

                                .v-label {
                                    width: 117px;
                                    font-weight: 600;
                                    color: #292929;
                                }

                                .value {
                                    width: 280px;
                                    line-height: 20px;
                                }
                            }
                        }

                        .read-more {
                            color: #1472bb;
                        }
                    }

                    .who {
                        background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_right_down_ico.svg) 0 -1px no-repeat;
                        background-size: 20px;
                    }
                }

                .head-block > div, &.head > div {
                    display: inline-block;
                    vertical-align: top;
                }

                .who {
                    width: 192px;
                    overflow: visible;

                    padding-left: 25px !important;

                    .details {
                        margin-top: 5px;

                        color: #666666;
                        white-space: nowrap;
                    }
                }

                .type,
                .what,
                .where,
                .when {
                    padding-left: 18px;
                }

                .type,
                .action,
                .where {
                    width: 160px;
                    word-break: break-all;
                }

                .action {
                    width: 144px;
                    span {
                        display: inline-block;
                        width: 9px;
                        height: 9px;
                    }
                }

                .what {
                    width: 240px;
                    word-break: break-all;
                }

                .when {
                    width: 133px;
                }
            }
        }

        .details {
            display: inline-block;
            width: 365px;
            vertical-align: top;

            .head {
                font-weight: 600;
                background-color: #d7effe;
                padding: 3px 18px;
                font-size: 12px;
                color: #202020;
            }

            .controls {
                color: #1472bb;
                font-size: 12px;
                font-weight: 400;
                line-height: 20px;
                text-align: right;
                padding: 10px 20px;
            }

            .details-table {
                margin-left: 20px;
                margin-bottom: 20px;
                .title, .col-left {
                    color: #202020;
                    font-size: 12px;
                    font-weight: 600;
                    line-height: 26px;
                }

                .col-left, .col-right {
                    display: inline-block;
                }
                .col-left {
                    width: 187px;
                }

                .col-right {
                    color: #202020;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 26px;

                    span {
                        color: #1472bb;
                        border-bottom: 1px solid rgba(20, 114, 187, 0.35);
                    }
                }
            }

            .btn {
                width: 180px;
                display: inline-block;
                border-radius: 0;
                padding: 3px 48px 3px 24px;

                &.exclude {
                    margin-right: 20px;
                    color: #ffffff;
                    background: #1472bb url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_right_white_ico.svg) no-repeat 97% 3px;
                    background-size: 20px 80%;

                }

                &.include {
                    color: #0d71b9;
                    border: 1px solid #0d71b9;

                    background: url(//img.netwrix.com/elements/onlineDemo/ui_icons/arrow_right_blue_ico.svg) 92% 3px no-repeat;
                    background-size: 20px 80%;
                }

                &.bordered {
                    outline: 2px solid #da262e;
                    outline-offset: 2px;
                }
            }
        }
    }

    .menu {
        width: 300px;
        padding: 0;
        border: 1px solid #3b8ac6;

        list-style-type: none;

        position: absolute;

        &.exclude {
            left: 206px;
            top: 0;
        }

        &.include {
            left: 413px;
            top: 0;
        }

        li {
            padding: 5px 12px;
            border-bottom: 1px solid #f3f3f3;

            color: #0d71b9;

            background-color: #eaeaea;
            cursor: not-allowed;

            &.active {
                background-color: #ffffff;
                cursor: pointer;
            }

            &:hover {
                background-color: #dff3fe
            }

        }
    }
</style>